import React, { PureComponent } from 'react'
import { Tabs, Tab } from '@material-ui/core'
import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import { getCategories } from '../../../actions/inventory'
import {
  getLeaflyAccounts,
  getLeaflyAccount,
  setLeaflyAccounts,
  setLeaflyAccount,
  updateLeaflyAccount,
  createLeaflyAccount,
  deleteLeaflyAccount,
  syncLeaflyAccount,
} from '../../../actions/thirdParty'
import { getShopList } from '../../../actions/shop'
import { connect } from 'react-redux'
import { globalValidator } from '../../../utils/validations/common'
import { openErrorMessage } from '../../../actions/message'
import LeaflyAccounts from '../../../components/Leafly/LeaflyAccounts'
import LeaflyMenu from '../../../components/Leafly/LeaflyMenu'

const leaflyTabs = ['Accounts', 'Menu']

class Leafly extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      leafly: {},
      lastModified: null,
      activeTab: leaflyTabs[0],
    }
  }

  leaflyTabs = leaflyTabs.map((tab) => <Tab label={tab} value={tab} />)

  componentDidMount() {
    this.props.dispatch(getShopList())
    this.getCategories()
    this.fetchLeaflyAccounts()
    this.getLeaflyAccount()
  }

  fetchLeaflyAccounts = () => {
    const data = {}

    this.props.dispatch(getLeaflyAccounts()).then((leaflyAccounts) => {
      leaflyAccounts &&
        leaflyAccounts.length &&
        leaflyAccounts.forEach((item) => {
          data[item.shopId] = { ...(data[item.shopId] || {}), ...item }
        })
      this.setState({
        leafly: data,
      })
      this.props.dispatch(setLeaflyAccounts(data))
    })
  }

  getLeaflyAccount = () => {
    this.props.dispatch(getLeaflyAccount()).then((leaflyAccount) => {
      this.props.dispatch(setLeaflyAccount(leaflyAccount))
    })
  }

  getCategories = () => {
    this.props.dispatch(getCategories()).then((res) => {
      this.setState({
        categoryLastModified: new Date().getTime(),
      })
    })
  }

  onSaveLeaflyAccount = (shopId) => (data, afterSave) => {
    const keys = [{ name: 'apiKey', title: 'Api Key', validateKey: 'required' }]

    const valid = globalValidator(data, keys)

    if (valid === true) {
      if (data.id) {
        delete data.shopName
        this.props.dispatch(updateLeaflyAccount(data)).then((res) => {
          this.fetchLeaflyAccounts()
          this.getLeaflyAccount()
          afterSave && afterSave()
        })
      } else {
        this.props.dispatch(createLeaflyAccount(data)).then((res) => {
          this.fetchLeaflyAccounts()
          this.getLeaflyAccount()
          afterSave && afterSave()
        })
      }
    } else {
      this.onError(valid)
    }
  }

  onDeleteLeaflyAccount = (leaflyAccountId) => {
    this.props.dispatch(deleteLeaflyAccount(leaflyAccountId)).then((res) => {
      this.fetchLeaflyAccounts()
    })
  }

  syncLeaflyAccount = () => {
    this.props.dispatch(syncLeaflyAccount()).then((res) => {})
  }

  handleTabChange = (event, tab) => {
    this.setState({
      activeTab: tab,
    })
  }

  onError = (msg) => this.props.dispatch(openErrorMessage(msg))

  renderTab = (activeTab) => {
    const { leafly = {} } = this.state
    const { leaflyAccount = {}, lastModified } = this.props.thirdPartyReducer
    const shopId = leaflyAccount.shopId
    const { shopsList = {} } = this.props.shopReducer
    const { categories = {} } = this.props.inventoryReducer

    switch (activeTab) {
      case 'Accounts':
        return (
          <LeaflyAccounts
            leafly={leafly}
            lastModified={lastModified}
            shopsList={shopsList}
            onSave={this.onSaveLeaflyAccount}
            onDelete={this.onDeleteLeaflyAccount}
          />
        )
      case 'Menu':
        return (
          <LeaflyMenu
            leaflyAccount={leaflyAccount}
            categoryList={categories.values}
            onSave={this.onSaveLeaflyAccount(shopId)}
            syncLeaflyAccount={this.syncLeaflyAccount}
            onError={this.onError}
            lastModified={lastModified}
          />
        )
      default:
        return null
    }
  }

  render() {
    const { activeTab } = this.state

    return (
      <div>
        <Tabs
          value={activeTab}
          onChange={this.handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          {this.leaflyTabs}
        </Tabs>
        {this.renderTab(activeTab)}
      </div>
    )
  }
}

const LeaflyWithTitle = ContainerWithTitleWrapper(Leafly, 'Leafly Settings')

export default connect((state) => {
  return {
    dispatch: state.dispatch,
    inventoryReducer: state.inventoryReducer,
    thirdPartyReducer: state.thirdPartyReducer,
    shopReducer: state.shopReducer,
  }
})(LeaflyWithTitle)



// WEBPACK FOOTER //
// ./src/containers/Settings/Integration/Leafly.js